function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M240.039 116.399L21.871 7.31531C18.9 5.82931 16.365 5.10742 14.121 5.10742C11.068 5.10742 8.52497 6.49342 7.14197 8.90942C5.32997 12.0764 5.90705 16.2264 8.85705 21.2454L65.677 117.883C67.972 121.787 71.6239 125.314 75.8669 128.027C71.6239 130.74 67.971 134.267 65.677 138.172L8.87598 234.809C5.92698 239.827 5.35001 243.977 7.16101 247.145C8.54401 249.561 11.088 250.947 14.141 250.947C16.385 250.947 18.92 250.224 21.891 248.738L240.037 139.656C246.293 136.528 247.956 133.176 247.956 128.028C247.958 122.674 246.294 119.526 240.039 116.399ZM75.16 112.308L20.152 18.7544L227.697 122.526H93.021C86.707 122.526 78.36 117.752 75.16 112.308ZM20.171 237.299L75.16 143.745C78.36 138.302 86.706 133.526 93.019 133.526H227.698L20.171 237.299Z",
  fill: "currentColor"
});

function SvgIconSend2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend2);
export default __webpack_public_path__ + "static/media/icon-send-2.94a62f8f595e36feeec9c3033d540c02.svg";
export { ForwardRef as ReactComponent };